import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import OpenCloseIndicationContainer from '../OpenCloseIndication/OpenCloseIndicationContainer.js';

const OpeningHours = (_param)=>{
    var { className , labels , regular , openingHours , specialOpeningHours , special =[] , isExpanded , onExpand , withTitle , announcement  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "regular",
        "openingHours",
        "specialOpeningHours",
        "special",
        "isExpanded",
        "onExpand",
        "withTitle",
        "announcement"
    ]);
     return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('location-opening-hours', {
            ['location-opening-hours--expanded']: isExpanded
        }, className)
    }), withTitle && /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "location-opening-hours__heading"
    }, labels.title), announcement && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: announcement
    }), /*#__PURE__*/ React__default.createElement(OpenCloseIndicationContainer, {
        openingHours: openingHours,
        specialOpeningHours: specialOpeningHours,
        isExpanded: isExpanded,
        onExpand: onExpand
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "location-opening-hours__lists"
    }, (special === null || special === void 0 ? void 0 : special.length) ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading2",
        component: "h3",
        className: "location-opening-hours__list-heading"
    }, labels.specialTitle), /*#__PURE__*/ React__default.createElement("dl", {
        className: "location-opening-hours__list"
    }, special.map(({ label , status , entries  })=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, {
            key: label
        }, /*#__PURE__*/ React__default.createElement("dt", {
            className: classnames('location-opening-hours__day')
        }, label), /*#__PURE__*/ React__default.createElement("dd", {
            className: classnames('location-opening-hours__hours', {
                'location-opening-hours__hours--closed': status === 'CLOSED'
            })
        }, entries.map(({ key , value  })=>/*#__PURE__*/ React__default.createElement("span", {
                key: key,
                className: "location-opening-hours__hours-entry"
            }, value)
        )))
    )), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading2",
        component: "span",
        className: "location-opening-hours__list-heading"
    }, labels.regularTitle)) : null, /*#__PURE__*/ React__default.createElement("dl", {
        className: "location-opening-hours__list"
    }, regular.map(({ label , today , status , entries  })=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, {
            key: label
        }, /*#__PURE__*/ React__default.createElement("dt", {
            className: classnames('location-opening-hours__day', {
                'location-opening-hours__day--today': today
            })
        }, label), /*#__PURE__*/ React__default.createElement("dd", {
            className: classnames('location-opening-hours__hours', {
                'location-opening-hours__hours--today': today,
                'location-opening-hours__hours--closed': status === 'CLOSED'
            })
        }, entries.map(({ key , value  })=>/*#__PURE__*/ React__default.createElement("span", {
                key: key,
                className: "location-opening-hours__hours-entry"
            }, value)
        )))
    ))));
};
var OpeningHours$1 = OpeningHours;

export { OpeningHours$1 as default };
//# sourceMappingURL=OpeningHours.js.map
